<template>
    <div style="width: 100%;text-align: center;height: 60%" @contextmenu.native="handlePaste($event)">
      <div style="width: 100%;text-align: center">
        <p style="font-size: 20px;font-weight: bolder;margin-bottom: 20px">{{title}}</p>
        <video
          v-if="resType == 'video'"
          controls
          id="video-style"
          controlslist="nodownload"
          :src="videoPath" type="video/mp4">
        </video>
        <audio
          v-else-if="resType == 'audio'"
          autuplay="autoplay"
          loop="loop"
          controls
          controlslist="nodownload">
          <source :src="videoPath" type="audio/mpeg">
        </audio>
        <div v-else style="font-size: 16px">{{resType}}</div>
      </div>
    </div>
</template>

<script>
  import axios from 'axios';
    export default {
      name: "Video",
      data(){
          return{
            videoPath: '', // 视频地址
            title: '',
            baseURL: 'https://teamer-online.oss-cn-shenzhen.aliyuncs.com/',
            resType: "video"
          }
      },
      mounted() {
        let uuId = this.$route.query.uuId
        this.getInitData(uuId);
      },
      methods:{
        handlePaste (event) {
          // 禁用鼠标右键
          event.preventDefault()
          return false
        },
        closePage(){
          // 关闭当前页面
          this.$router.back()
        },
        getInitData(uuId){
          // 获取初始化数据
          // let url = "https://open.nfclass.com/management/common/get/resource?sId=a00450d05f2f155f"
          let url = "https://open.nfclass.com/management/common/get/resource?sId=" + uuId
          axios.get(url)
            .then(res=>{
              this.title = res["data"]["data"]["fileTitle"]
              this.videoPath = this.baseURL + res["data"]["data"]["realTitle"]
              if (this.videoPath.slice(-3) == "mp4"){
                this.resType = "video"
              } else if (this.videoPath.slice(-3) == "mp3"){
                this.resType = "audio"
              } else{
                this.resType = "该资源类型不支持播放！"
              }

            })

        }
      }
    }
</script>

<style scoped>
#video-style{
  /*margin-top: 10px;*/
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 10px;
  border: 1px solid #555;
}
</style>